import React from 'react';
import { object, string } from 'prop-types';
import '../styles/ChildCategories.css';
import { Link } from 'react-router-dom';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

function ChildCategories ({ title, hierarchy }) {
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const current = hierarchy.default?.filter((category) => category.LEVEL === 2);

    if (!current?.length) {
        return null;
    }

    return (
        <div
            className={'child-categories--wrapper'}>
            <h4
                className={'text-uppercase'}>{title}</h4>
            <ul
                className={'child-categories-container'}
            >
                {current
                    .sort((a, b) => a.title.localeCompare(b.title))
                    .map(({ id, title, handle }) => (<li
                        className={'child-categories-item'}
                        key={id}
                    >
                        <Link
                            className={'child-categories-link'}
                            to={`${collectionPath[0].pathBeforeParams}/${handle}`}
                        >
                            {title}
                        </Link>
                    </li>))
                }
            </ul>
        </div>
    );
}

ChildCategories.propTypes = {
    hierarchy: object,
    title: string,
};

export default ChildCategories;